"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_VIDEO_LIST_VALUES = void 0;
var CHANNEL_VIDEO_LIST_VALUES;
(function (CHANNEL_VIDEO_LIST_VALUES) {
    CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["EXPAND_ON_CLICK"] = 1] = "EXPAND_ON_CLICK";
    CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["ALWAYS_SHOW"] = 2] = "ALWAYS_SHOW";
    CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["NEVER_SHOW"] = 3] = "NEVER_SHOW";
})(CHANNEL_VIDEO_LIST_VALUES = exports.CHANNEL_VIDEO_LIST_VALUES || (exports.CHANNEL_VIDEO_LIST_VALUES = {}));
//# sourceMappingURL=channel-video-list-values.js.map